import IC_CLOUD from "@/assets/flow/ic_cloud.svg?react";
import IC_LOCAL from "@/assets/flow/ic_export.svg?react";
import IC_ARROW from "@/assets/flow/ic_arrow_right.svg?react";
import dataFolwStore from "@/store/endSideFlow.store";
import { useEffect, useRef } from "react";
import { DataFlowApis } from "@core/ability";
import { message } from "antd";
import fridayReporter from "@/utils/friday";

interface IExportOptions {
  id: string;
  title: string;
  desc: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const exportType: IExportOptions[] = [
  {
    id: "cloud",
    title: "保存到Maxhub会记",
    desc: "为你生成可在线编辑的会记文件",
    icon: IC_CLOUD,
  },
  {
    id: "local",
    title: "导出到本地",
    desc: "为你导出原文、智能总结和音频",
    icon: IC_LOCAL,
  }
];

const transformPort = [52781, 52768, 52732];

export default function ChoseTypeView() {

  const remoteIp = dataFolwStore((store) => store.remoteIp);

  const rightPort = useRef<number | undefined>();

  useEffect(() => {
    searchPort();
  }, []);

  const searchPort = async () => {
    if (remoteIp) {
      for (let i = 0; i < transformPort.length; i++) {
        const res = await DataFlowApis.checkHealth(remoteIp, transformPort[i]);
        if (res) {
          rightPort.current = transformPort[i];
          dataFolwStore.getState().setRightPort(transformPort[i]);
          break;
        }
      }
    }
  }

  const clickHandle = async (id: string) => {
    if (!rightPort.current) {
      message.warning('会议平板端口被占用，请稍后重试');
      searchPort();
      return;
    }
    if (id === "local") {
      fridayReporter.pushData({
        eventCode: 'HomePage_GetFiles_ExportLocal'
      })
      const res = await DataFlowApis.selectSavePath();
      console.log(res);
      if (!res) {
        message.warning("选择保存路径出错，请稍后再试");
        return;
      }
      if (res.canceled) {
        console.log('取消路径选择');
        message.warning("请选择文件保存的路径");
        return;
      } else {
        dataFolwStore.getState().setLocalFileSavePath(res.filePaths[0]);
        dataFolwStore.getState().setIsClound(false);
        dataFolwStore.getState().changeSection(3);
      }
    } else {
      fridayReporter.pushData({
        eventCode: 'HomePage_GetFiles_SaveCloud'
      })
      dataFolwStore.getState().setIsClound(true);
      dataFolwStore.getState().changeSection(3);
    }
  }

  return (
    <div className="flex flex-col flex-1 items-center ml-6 mr-6 justify-center">
      {exportType.map((item) => {
        return (
          <div key={item.id}
            className="w-full h-22.75 border-solid border-#ECEEF3 border-0.25 rounded-4 p-6 cursor-pointer my-1"
            onClick={() => { clickHandle(item.id); }
            }>
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full flex justify-center items-center bg-#F4F6F9">
                <item.icon className="w-6 h-6"></item.icon>
              </div>
              <div className="flex flex-1 flex-col ml-4">
                <span className="text-size-4 text-black font-500">{item.title}</span>
                <span className="text-size-3 text-#A1A7B2 font-400 mt-1">{item.desc}</span>
              </div>
              <IC_ARROW className="w-4 h-4"></IC_ARROW>
            </div>
          </div>
        );
      })}
    </div >
  );
}